// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationTemplateQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type PresentationTemplateQuery = { __typename?: 'Query', presentationTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & PresentationTemplateEditor_PresentationTemplateFragment
      ) | null } | null> | null } };

export type PresentationTemplateEditor_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, tenantID: string, luminaryOrganizationID?: string | null, systemTemplateKind?: Types.PresentationTemplateSystemTemplateKind | null, bundles: { __typename?: 'PresentationTemplateBundleConnection', edges?: Array<{ __typename?: 'PresentationTemplateBundleEdge', node?: (
        { __typename?: 'PresentationTemplateBundle' }
        & PresentationTemplateEditor_PresentationTemplateBundleFragment
      ) | null } | null> | null } };

export type PresentationTemplateEditor_PresentationTemplateBundleFragment = { __typename?: 'PresentationTemplateBundle', id: string, kind: Types.PresentationBundleKind, templateNotes?: string | null, excludeFromOutput: boolean, additionalPromptContext?: string | null, dividerTemplateBundleConfiguration?: { __typename?: 'DividerTemplateBundleConfiguration', id: string, dividerTitle?: string | null, customContent?: string | null } | null, waterfallTemplateBundleConfiguration?: { __typename?: 'WaterfallTemplateBundleConfiguration', id: string, includeCoverPage: boolean, includeAssumptionsPage: boolean, includeSummaryPage: boolean, includeSummaryBars?: boolean | null, includeSummaryTiles?: boolean | null, showSummaryTileDetails: boolean, includeDiagramPage: boolean, includeTaxOverviewPage: boolean, includeOverview: boolean, includeBeforeFirstDeath: boolean, includeAfterFirstDeath: boolean, includeAfterSecondDeath: boolean, summaryHideZeroDollarItems: boolean } | null, waterfallComparisonTemplateBundleConfiguration?: { __typename?: 'WaterfallComparisonTemplateBundleConfiguration', id: string, includeCoverPage: boolean, includeAssumptionsPage: boolean } | null, documentSummaryTemplateBundleConfiguration?: { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string, documentType?: Types.PresentationDocumentType | null, includeFirstGrantor: boolean, includeSecondGrantor: boolean } | null, beneficiariesTemplateBundleConfiguration?: { __typename?: 'BeneficiariesTemplateBundleConfiguration', id: string, includeHouseholdOverview: boolean, includeIndividualOverviews: boolean } | null, insightsTemplateBundleConfiguration?: { __typename?: 'InsightsTemplateBundleConfiguration', id: string, includeActiveInsights: boolean, includeMissingDocuments: boolean, includeCompletedInsights: boolean } | null, entitySummaryTemplateBundleConfiguration?: { __typename?: 'EntitySummaryTemplateBundleConfiguration', id: string, entityTypes: Array<Types.EntitySummaryEntityType>, includeEntitySummaryPage: boolean, includeDiagramAndNotesPage: boolean, includeBalanceSheetPage: boolean, includeBalanceSheetExportPage: boolean, includeBeneficiariesAndDispositionsPage: boolean, includeInsurancePolicySlides: boolean, includeEntityNotesOnSummaryPage: boolean } | null, pages: { __typename?: 'PresentationTemplatePageConnection', edges?: Array<{ __typename?: 'PresentationTemplatePageEdge', node?: (
        { __typename?: 'PresentationTemplatePage' }
        & PresentationTemplateEditor_PresentationTemplatePageFragment
      ) | null } | null> | null } };

export type PresentationTemplateEditor_PresentationTemplatePageFragment = { __typename?: 'PresentationTemplatePage', id: string, kind: Types.PresentationPageKind, customPage?: { __typename?: 'PresentationTemplateCustomPage', id: string, pageName: string, pageContent: string, pageHeader: string, pageSubheader?: string | null, includePageHeader?: boolean | null, customPrompt?: string | null } | null, diagramPage?: { __typename?: 'PresentationTemplateDiagramPage', id: string, pageName: string } | null, coverPage?: { __typename?: 'PresentationTemplateCoverPage', id: string, displayTitle?: string | null, customContent?: string | null, customPrompt?: string | null } | null };

export type UpdatePresentationTemplateMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdatePresentationTemplateInput;
}>;


export type UpdatePresentationTemplateMutation = { __typename?: 'Mutation', updatePresentationTemplate: (
    { __typename?: 'PresentationTemplate' }
    & PresentationTemplateEditor_PresentationTemplateFragment
  ) };

export const Operations = {
  Query: {
    PresentationTemplate: 'PresentationTemplate' as const
  },
  Mutation: {
    UpdatePresentationTemplate: 'UpdatePresentationTemplate' as const
  },
  Fragment: {
    PresentationTemplateEditor_PresentationTemplate: 'PresentationTemplateEditor_PresentationTemplate' as const,
    PresentationTemplateEditor_PresentationTemplateBundle: 'PresentationTemplateEditor_PresentationTemplateBundle' as const,
    PresentationTemplateEditor_PresentationTemplatePage: 'PresentationTemplateEditor_PresentationTemplatePage' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationTemplateEditor_PresentationTemplatePageFragmentDoc = gql`
    fragment PresentationTemplateEditor_PresentationTemplatePage on PresentationTemplatePage {
  id
  kind
  customPage {
    id
    pageName
    pageContent
    pageHeader
    pageSubheader
    includePageHeader
    customPrompt
  }
  diagramPage {
    id
    pageName
  }
  coverPage {
    id
    displayTitle
    customContent
    customPrompt
  }
}
    `;
export const PresentationTemplateEditor_PresentationTemplateBundleFragmentDoc = gql`
    fragment PresentationTemplateEditor_PresentationTemplateBundle on PresentationTemplateBundle {
  id
  kind
  templateNotes
  excludeFromOutput
  additionalPromptContext
  dividerTemplateBundleConfiguration {
    id
    dividerTitle
    customContent
  }
  waterfallTemplateBundleConfiguration {
    id
    includeCoverPage
    includeAssumptionsPage
    includeSummaryPage
    includeSummaryBars
    includeSummaryTiles
    showSummaryTileDetails
    includeDiagramPage
    includeTaxOverviewPage
    includeOverview
    includeBeforeFirstDeath
    includeAfterFirstDeath
    includeAfterSecondDeath
    summaryHideZeroDollarItems
  }
  waterfallComparisonTemplateBundleConfiguration {
    id
    includeCoverPage
    includeAssumptionsPage
  }
  documentSummaryTemplateBundleConfiguration {
    id
    documentType
    includeFirstGrantor
    includeSecondGrantor
  }
  beneficiariesTemplateBundleConfiguration {
    id
    includeHouseholdOverview
    includeIndividualOverviews
  }
  insightsTemplateBundleConfiguration {
    id
    includeActiveInsights
    includeMissingDocuments
    includeCompletedInsights
  }
  entitySummaryTemplateBundleConfiguration {
    id
    entityTypes
    includeEntitySummaryPage
    includeDiagramAndNotesPage
    includeBalanceSheetPage
    includeBalanceSheetExportPage
    includeBeneficiariesAndDispositionsPage
    includeInsurancePolicySlides
    includeEntityNotesOnSummaryPage
  }
  pages(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        ...PresentationTemplateEditor_PresentationTemplatePage
      }
    }
  }
}
    ${PresentationTemplateEditor_PresentationTemplatePageFragmentDoc}`;
export const PresentationTemplateEditor_PresentationTemplateFragmentDoc = gql`
    fragment PresentationTemplateEditor_PresentationTemplate on PresentationTemplate {
  id
  displayName
  tenantID
  luminaryOrganizationID
  systemTemplateKind
  bundles(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        ...PresentationTemplateEditor_PresentationTemplateBundle
      }
    }
  }
}
    ${PresentationTemplateEditor_PresentationTemplateBundleFragmentDoc}`;
export const PresentationTemplateDocument = gql`
    query PresentationTemplate($templateId: ID!) {
  presentationTemplates(where: {id: $templateId}) {
    edges {
      node {
        ...PresentationTemplateEditor_PresentationTemplate
      }
    }
  }
}
    ${PresentationTemplateEditor_PresentationTemplateFragmentDoc}`;

/**
 * __usePresentationTemplateQuery__
 *
 * To run a query within a React component, call `usePresentationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePresentationTemplateQuery(baseOptions: Apollo.QueryHookOptions<PresentationTemplateQuery, PresentationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationTemplateQuery, PresentationTemplateQueryVariables>(PresentationTemplateDocument, withFetchPolicyContext(options));
      }
export function usePresentationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationTemplateQuery, PresentationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationTemplateQuery, PresentationTemplateQueryVariables>(PresentationTemplateDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationTemplateQuery, PresentationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationTemplateQuery, PresentationTemplateQueryVariables>(PresentationTemplateDocument, withFetchPolicyContext(options));
        }
export type PresentationTemplateQueryHookResult = ReturnType<typeof usePresentationTemplateQuery>;
export type PresentationTemplateLazyQueryHookResult = ReturnType<typeof usePresentationTemplateLazyQuery>;
export type PresentationTemplateSuspenseQueryHookResult = ReturnType<typeof usePresentationTemplateSuspenseQuery>;
export type PresentationTemplateQueryResult = Apollo.QueryResult<PresentationTemplateQuery, PresentationTemplateQueryVariables>;
export const UpdatePresentationTemplateDocument = gql`
    mutation UpdatePresentationTemplate($input: AugmentedUpdatePresentationTemplateInput!) {
  updatePresentationTemplate(input: $input) {
    ...PresentationTemplateEditor_PresentationTemplate
  }
}
    ${PresentationTemplateEditor_PresentationTemplateFragmentDoc}`;
export type UpdatePresentationTemplateMutationFn = Apollo.MutationFunction<UpdatePresentationTemplateMutation, UpdatePresentationTemplateMutationVariables>;

/**
 * __useUpdatePresentationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdatePresentationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresentationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresentationTemplateMutation, { data, loading, error }] = useUpdatePresentationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePresentationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePresentationTemplateMutation, UpdatePresentationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePresentationTemplateMutation, UpdatePresentationTemplateMutationVariables>(UpdatePresentationTemplateDocument, options);
      }
export type UpdatePresentationTemplateMutationHookResult = ReturnType<typeof useUpdatePresentationTemplateMutation>;
export type UpdatePresentationTemplateMutationResult = Apollo.MutationResult<UpdatePresentationTemplateMutation>;
export type UpdatePresentationTemplateMutationOptions = Apollo.BaseMutationOptions<UpdatePresentationTemplateMutation, UpdatePresentationTemplateMutationVariables>;